__turbopack_context__.v({
  "chevron": "ffKk8W_chevron",
  "collapsed": "ffKk8W_collapsed",
  "collapsed-text": "ffKk8W_collapsed-text",
  "content": "ffKk8W_content",
  "down": "ffKk8W_down",
  "expanded": "ffKk8W_expanded",
  "icon": "ffKk8W_icon",
  "icons": "ffKk8W_icons",
  "reveal": "ffKk8W_reveal",
  "reveal-text": "ffKk8W_reveal-text",
  "tech-stack": "ffKk8W_tech-stack",
  "text": "ffKk8W_text",
  "title": "ffKk8W_title",
  "tooltip": "ffKk8W_tooltip",
  "up": "ffKk8W_up",
});
